module.exports = __webpack_public_path__ + "static/media/Vimeo.caaec5ab.svg";